import { StepKey } from '/@/modules/guidancestep/enums/StepKey';
import { Step541360Meta } from '/@/modules/guidancestep/models/meta/Step541360Meta';
import { Step613645Meta } from '/@/modules/guidancestep/models/meta/Step613645Meta';
import { Step727745Meta } from '/@/modules/guidancestep/models/meta/Step727745Meta';
import { Step483248Meta } from '/@/modules/guidancestep/models/meta/Step483248Meta';
import { Step144263Meta } from '/@/modules/guidancestep/models/meta/Step144263Meta';
import { Step136784Meta } from '/@/modules/guidancestep/models/meta/Step136784Meta';
import { Step141971Meta } from '/@/modules/guidancestep/models/meta/Step141971Meta';
import { Step902407Meta } from '/@/modules/guidancestep/models/meta/Step902407Meta';
import { Step282435Meta } from '/@/modules/guidancestep/models/meta/Step282435Meta';
import { Step658608Meta } from '/@/modules/guidancestep/models/meta/Step658608Meta';
import { Step982103Meta } from '/@/modules/guidancestep/models/meta/Step982103Meta';
import { Step409063Meta } from '/@/modules/guidancestep/models/meta/Step409063Meta';
import { Step919460Meta } from '/@/modules/guidancestep/models/meta/Step919460Meta';
import { Step749361Meta } from '/@/modules/guidancestep/models/meta/Step749361Meta';
import { Step941468Meta } from '/@/modules/guidancestep/models/meta/Step941468Meta';
import { Step146420Meta } from '/@/modules/guidancestep/models/meta/Step146420Meta';
import { Step293616Meta } from '/@/modules/guidancestep/models/meta/Step293616Meta';
import { Step591073Meta } from '/@/modules/guidancestep/models/meta/Step591073Meta';
import { Step356581Meta } from '/@/modules/guidancestep/models/meta/Step356581Meta';
import { Step244100Meta } from '/@/modules/guidancestep/models/meta/Step244100Meta';
import { Step530031Meta } from '/@/modules/guidancestep/models/meta/Step530031Meta';
import { Step761548Meta } from '@/modules/guidancestep/models/meta/Step761548Meta';
import { Step410647Meta } from '/@/modules/guidancestep/models/meta/Step410647Meta';
import { Step340074Meta } from '/@/modules/guidancestep/models/meta/Step340074Meta';
import { Step498673Meta } from '/@/modules/guidancestep/models/meta/Step498673Meta';
import { Step525888Meta } from '/@/modules/guidancestep/models/meta/Step525888Meta';
import { Step233636Meta } from '@/modules/guidancestep/models/meta/Step233636Meta';
import { Step456401Meta } from '@/modules/guidancestep/models/meta/Step456401Meta';
import { Step332566Meta } from '@/modules/guidancestep/models/meta/Step332566Meta';
import { Step426797Meta } from '@/modules/guidancestep/models/meta/Step426797Meta';
import { Step192329Meta } from '@/modules/guidancestep/models/meta/Step192329Meta';
import { Step997411Meta } from '@/modules/guidancestep/models/meta/Step997411Meta';
import { Step944328Meta } from '@/modules/guidancestep/models/meta/Step944328Meta';
import { Step922045Meta } from '/@/modules/guidancestep/models/meta/Step922045Meta';
import { Step138672Meta } from '@/modules/guidancestep/models/meta/Step138672Meta';

export class GuidanceStepMeta {
  static factory(key, meta = {}) {
    switch (key) {
      case StepKey.STEP_541360:
        return Step541360Meta.mapModel(meta);
      case StepKey.STEP_613645:
        return Step613645Meta.mapModel(meta);
      case StepKey.STEP_727745:
        return Step727745Meta.mapModel(meta);
      case StepKey.STEP_483248:
        return Step483248Meta.mapModel(meta);
      case StepKey.STEP_144263:
        return Step144263Meta.mapModel(meta);
      case StepKey.STEP_902407:
        return Step902407Meta.mapModel(meta);
      case StepKey.STEP_136784:
        return Step136784Meta.mapModel(meta);
      case StepKey.STEP_282435:
        return Step282435Meta.mapModel(meta);
      case StepKey.STEP_141971:
        return Step141971Meta.mapModel(meta);
      case StepKey.STEP_658608:
        return Step658608Meta.mapModel(meta);
      case StepKey.STEP_982103:
        return Step982103Meta.mapModel(meta);
      case StepKey.STEP_409063:
        return Step409063Meta.mapModel(meta);
      case StepKey.STEP_919460:
        return Step919460Meta.mapModel(meta);
      case StepKey.STEP_146420:
        return Step146420Meta.mapModel(meta);
      case StepKey.STEP_749361:
        return Step749361Meta.mapModel(meta);
      case StepKey.STEP_192329:
        return Step192329Meta.mapModel(meta);
      case StepKey.STEP_944328:
        return Step944328Meta.mapModel(meta);
      case StepKey.STEP_941468:
        return Step941468Meta.mapModel(meta);
      case StepKey.STEP_293616:
        return Step293616Meta.mapModel(meta);
      case StepKey.STEP_591073:
        return Step591073Meta.mapModel(meta);
      case StepKey.STEP_356581:
        return Step356581Meta.mapModel(meta);
      case StepKey.STEP_244100:
        return Step244100Meta.mapModel(meta);
      case StepKey.STEP_530031:
        return Step530031Meta.mapModel(meta);
      case StepKey.STEP_761548:
        return Step761548Meta.mapModel(meta);
      case StepKey.STEP_410647:
        return Step410647Meta.mapModel(meta);
      case StepKey.STEP_340074:
        return Step340074Meta.mapModel(meta);
      case StepKey.STEP_456401:
        return Step456401Meta.mapModel(meta);
      case StepKey.STEP_498673:
        return Step498673Meta.mapModel(meta);
      case StepKey.STEP_525888:
        return Step525888Meta.mapModel(meta);
      case StepKey.STEP_233636:
        return Step233636Meta.mapModel(meta);
      case StepKey.STEP_332566:
        return Step332566Meta.mapModel(meta);
      case StepKey.STEP_426797:
        return Step426797Meta.mapModel(meta);
      case StepKey.STEP_997411:
        return Step997411Meta.mapModel(meta);
      case StepKey.STEP_922045:
        return Step922045Meta.mapModel(meta);
      case StepKey.STEP_138672:
        return Step138672Meta.mapModel(meta);
      default:
        return {};
    }
  }
}
